import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../constants/size'
import Modal, { Box, Header } from '../../Modal'

import { useSequenceModalActions } from './DocFlowEditSequenceModal.hooks'
import { DocFlowEditSequenceModalActions } from './DocFlowEditSequenceModalActions'
import { DocFlowEditSequenceModalConfirmation } from './DocFlowEditSequenceModalConfirmation'
import { DocFlowEditSequenceModalContent } from './DocFlowEditSequenceModalContent'

function DocFlowEditSequenceModal(props) {
  const { t } = useTranslation()

  const {
    handleClose,
    handleDragEnd,
    handleSubmit,
    isCloseConfirm,
    isLoading,
    notificationList,
    setCloseConfirm,
    updatedList,
  } = useSequenceModalActions(props)

  return (
    <>
      <DocFlowEditSequenceModalConfirmation
        isCloseConfirm={isCloseConfirm}
        onClose={props.onClose}
        onSetCloseConfirm={setCloseConfirm}
      />
      <Modal onClose={handleClose}>
        <Box size={SIZE.MEDIUM}>
          <Header
            text={t('DocumentStapling.EditSplittedDocumentModalTitleKey')}
            onClose={handleClose}
          />

          <DocFlowEditSequenceModalContent
            isLoading={isLoading}
            notificationList={notificationList}
            updatedList={updatedList}
            onDragEnd={handleDragEnd}
          />

          <DocFlowEditSequenceModalActions
            isLoading={isLoading}
            onClose={handleClose}
            onSubmit={handleSubmit}
          />
        </Box>
      </Modal>
    </>
  )
}

export default DocFlowEditSequenceModal
